import { useMutation, useQueryClient } from 'react-query';
import { ENVIRONMENT_NAME_QUERY_KEY } from '../../constants/query';
import environmentService from '../../services/environment.service';

const useRegenerateKey = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: ({ activeEnvironmentId }) =>
      environmentService.changeEnvironmentDeviceLoggingKey({ customerEnvId: activeEnvironmentId }),
    onSuccess: (_data, { activeEnvironmentId }) => {
      queryClient.invalidateQueries([ENVIRONMENT_NAME_QUERY_KEY, activeEnvironmentId]);
    },
  });
};

export default useRegenerateKey;
